<template>
  <notifications position="top center" :max="5" />
  <template v-if="!loading && isAuthenticated && checkedUserMode">
    <div class="h-full">
      <div class="wrap-content flex flex-col h-full">
        <div class="h-12 shadow-md z-30 hidden sm:block">
          <div class="flex justify-between">
            <div id="content" class="ml-3 flex flex-wrap content-center">
              <router-link :to="{ name: 'vehiclesMap' }" class="py-2">
                <img
                  class="h-8 w-8"
                  src="/images/favicons/favicon-32x32.png"
                  alt="Workflow"
                />
              </router-link>
              <div class="flex flex-col justify-center">
                <div class="flex gap-5 ml-8">
                  <a :href="getOctlinkURL()" target="_blank">
                    <div>
                      {{ $t('common.menu.octlink.text') }}
                    </div>
                  </a>
                  <router-link
                    :to="{ name: 'searchRoute' }"
                    data-test="open-route-list-link-desktop"
                    v-if="!isItThePage('searchRoute')"
                  >
                    <div>
                      {{ $t('common.menu.routeSearch.text') }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="pr-3 flex flex-wrap content-center">
              <div class="pr-3 flex items-center justify-center">
                <div
                  style="max-width: 12rem"
                  class="text-sm flex flex-col justify-center"
                >
                  <div class="truncate">
                    {{ myOfficeName }}
                  </div>
                  <div class="truncate">
                    {{ user?.email }}
                  </div>
                </div>
              </div>
              <div class="relative flex items-center">
                <button
                  @click="togglePopup()"
                  data-test="right-menu-toggle"
                  class="flex items-center justify-center"
                >
                  <v-icon
                    icon="account_circle"
                    :outlined="true"
                    class="account-icon"
                  />
                </button>
                <div
                  v-if="isPopupShow"
                  id="account_menu"
                  class="absolute right-0 top-full bg-white border border-gray-200 rounded-md py-1 px-2 block w-max"
                >
                  <div
                    id="alert-notification"
                    class="alert-notification flex flex-wrap content-center mt-1 mb-2"
                  >
                    <div
                      style="max-width: 17rem"
                      class="alert-notification mr-2"
                    >
                      <label
                        for="alert-notification-toggle"
                        class="alert-notification flex items-center cursor-pointer"
                      >
                        <!-- toggle -->
                        <div class="alert-notification relative">
                          <!-- input -->
                          <input
                            type="checkbox"
                            id="alert-notification-toggle"
                            class="alert-notification sr-only"
                            v-on:change="switchAlertNotification"
                            v-bind:checked="alertNotification"
                          />
                          <!-- line -->
                          <div
                            class="alert-notification block bg-stone-400 w-14 h-8 rounded-full"
                          ></div>
                          <!-- dot -->
                          <div
                            class="alert-notification dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"
                          ></div>
                        </div>
                        <!-- label -->
                        <div
                          class="alert-notification ml-3 text-gray-700 font-medium"
                        >
                          {{ $t('common.menu.sensorAlertNotification.text') }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-if="shouldShowLinkToSelectOffice" class="mb-2">
                    <router-link
                      :to="{ name: 'selectOperationOffice' }"
                      class="pointer-events-auto flex"
                    >
                      <v-icon icon="switch_account" />
                      <span class="pl-2">
                        {{ $t('pages.mainTemplate.selectOperationOffice') }}
                      </span>
                    </router-link>
                  </div>
                  <div
                    class="cursor-pointer flex"
                    @click="logoutAndRedirect()"
                    data-test="logout-btn"
                  >
                    <v-icon icon="logout" class="text-lg" />
                    <div class="pl-2 pt-0.5">
                      {{ $t('pages.mainTemplate.logoutBtn') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h-12 shadow-md z-40 sm:hidden">
          <div class="flex justify-between">
            <div id="mobile-content" class="ml-3 flex flex-wrap content-center">
              <router-link
                :to="{ name: 'vehiclesMap' }"
                class="pointer-events-auto"
              >
                <img src="/images/favicons/favicon-32x32.png" alt="Workflow" />
              </router-link>

              <div class="flex flex-col justify-center">
                <div class="flex gap-5 ml-8 header-blank">
                  <a :href="getOctlinkURL()" target="_blank">
                    <div>
                      {{ $t('common.menu.octlink.text') }}
                    </div>
                  </a>
                  <router-link
                    :to="{ name: 'searchRoute' }"
                    data-test="open-route-list-link-mobile"
                    v-if="!isItThePage('searchRoute')"
                  >
                    <div>
                      {{ $t('common.menu.routeSearch.text') }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="h-12 pr-3 flex flex-wrap content-center">
              <div class="relative flex items-center">
                <button
                  @click="togglePopup()"
                  class="flex items-center justify-center"
                >
                  <v-icon
                    icon="account_circle"
                    :outlined="true"
                    class="account-icon"
                  />
                </button>
                <div
                  v-if="isPopupShow"
                  id="account_menu"
                  class="absolute right-0 top-full bg-white border border-gray-200 rounded-md py-1 px-2 text-sm block w-max"
                >
                  <div
                    class="pt-1 pl-5 pb-2 border-b-2 border-gray-300 truncate"
                  >
                    <div class="w-40">
                      <div class="truncate">
                        {{ myOfficeName }}
                      </div>
                      <div class="truncate">
                        {{ user?.email }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="alert-notification m-1 mt-2 mb-2">
                      <div
                        class="alert-notification flex items-center justify-center w-full"
                      >
                        <label
                          for="alert-notification-toggle-mobile"
                          class="alert-notification flex items-center cursor-pointer"
                        >
                          <!-- toggle -->
                          <div class="alert-notification relative">
                            <!-- input -->
                            <input
                              type="checkbox"
                              id="alert-notification-toggle-mobile"
                              class="alert-notification sr-only"
                              v-on:change="switchAlertNotification"
                              v-bind:checked="alertNotification"
                            />
                            <!-- line -->
                            <div
                              class="alert-notification block bg-stone-400 w-14 h-8 rounded-full"
                            ></div>
                            <!-- dot -->
                            <div
                              class="alert-notification dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"
                            ></div>
                          </div>
                          <!-- label -->
                          <div
                            class="alert-notification ml-3 text-gray-700 font-medium"
                          >
                            {{ $t('common.menu.sensorAlertNotification.text') }}
                          </div>
                        </label>
                      </div>
                    </div>
                    <div
                      class="cursor-pointer flex pt-1.5 pb-1"
                      @click="logoutAndRedirect()"
                    >
                      <v-icon icon="logout" class="text-base" />
                      <div class="pl-1 pt-0.5">
                        {{ $t('pages.mainTemplate.logoutBtn') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </template>
  <template v-else>
    <div
      class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div class="max-w-md w-full space-y-8">
        <v-loader-animation
          :text="'text-black'"
          :loading-text-style="'text-black text-lg'"
          :loading-text="$t('common.loadingText')"
        />
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import VIcon from '@/components/template/v-icon.vue'
import { useAuth } from '@/services/user/Auth0UserProvider'
import store from '@/services/store'
import subscribeService from '@/services/subscribe/SubscribeServiceFabrick'
import { isItThePage, redirectDriverMode } from '@/routes'
import { computed, onMounted, ref } from 'vue'
import Api from '@/services/api/ApiServiceFabrick'
import VLoaderAnimation from '@/components/template/v-loader-animation.vue'
import useLogout from '@/composables/useLogout'

const { isAuthenticated, loading, user } = useAuth()
const { logoutAndRedirect } = useLogout()

const myOfficeName = ref('')
const checkedUserMode = ref(false)

let isPopupShow = ref(false)
let popupCnt = 0

const alertNotification = ref(
  localStorage.getItem('alertNotification') !== 'false' // 値が無い場合とtrueの場合は通知をONにする
)

onMounted(async () => {
  const isRedirected = await redirectDriverMode()
  checkedUserMode.value = !isRedirected
  if (isRedirected) {
    return
  }
  if (store.state.myOffice == null) {
    Api()
      .getMyOffice()
      .then((res) => {
        myOfficeName.value = res?.name ?? ''
      })
  } else {
    myOfficeName.value = store.getters.plainMyOffice.name ?? null
  }
})

const shouldShowLinkToSelectOffice = computed(() => {
  const selectableOffices =
    store.getters.plainSelectableOperationOffices?.operation_offices ?? []
  return selectableOffices.length > 0
})

const hidePopup = () => {
  isPopupShow.value = false
  document.removeEventListener('click', popupEvent)
  popupCnt = 0
}

const popupEvent = (e: Event) => {
  const targets = document.querySelectorAll('.alert-notification')
  const arr = Array.prototype.slice.call(targets)
  if (
    isPopupShow.value &&
    e.target != document.getElementById('account_menu') &&
    arr.indexOf(e.target) == -1
  ) {
    if (popupCnt != 0) {
      togglePopup()
    } else {
      popupCnt++
    }
  }
}

const togglePopup = () => {
  if (!isPopupShow.value) {
    isPopupShow.value = true
    document.addEventListener('click', popupEvent)
  } else {
    hidePopup()
  }
}

const switchAlertNotification = (event) => {
  alertNotification.value = event.target.checked
  localStorage.setItem('alertNotification', event.target.checked)
  subscribeService().switchAlertNotification(event.target.checked)
  event.stopPropagation()
}

const getOctlinkURL = () => {
  return process.env.VUE_APP_OCTLINK_URL || ''
}
</script>

<style>
html,
body,
#app {
  height: 100%;
}
.bg-stone-400 {
  background-color: rgb(209 213 219);
}
.sr-only:checked ~ .bg-stone-400 {
  background-color: #3ec377;
}
/* Toggle A */
.sr-only:checked ~ .dot {
  transform: translateX(100%);
}

/* Toggle B */
.sr-only:checked ~ .dot {
  transform: translateX(100%);
}
</style>
<style scoped>
.header-blank {
  margin-left: 2rem;
}

@media (max-width: 400px) {
  .header-blank {
    margin-left: 1rem;
  }
}

:deep(.account-icon) {
  font-size: 30px;
}
</style>
